// import React from 'react';
// import Link from '@mui/material/Link';
// import { useSelector } from 'react-redux';
// import { LinkItems } from 'utils/commonUtils';
// import { LinkWrapperGrid } from 'components/Ui/styled';

// const DashboardLaunch = () => {
//   const studentLinks = useSelector((state) => state.dashboard.studentLinks);
//   return (
//     <>
//       {studentLinks?.map((item, index) => {
//         return (
//           <Link href={item.url} target="_blank" key={index}>
//             <LinkWrapperGrid>
//               <LinkItems title={item.title} />
//             </LinkWrapperGrid>
//           </Link>
//         );
//       })}
//     </>
//   );
// };

// export default DashboardLaunch;

import React, { useEffect, useRef, useState } from 'react';
import Link from '@mui/material/Link';
import { useSelector } from 'react-redux';
import {
  LaunchGrid,
  LaunchCard,
  LaunchIcon,
  LaunchLabel,
} from 'components/Ui/styled';
import Tooltip from '@mui/material/Tooltip';

const DashboardLaunch = () => {
  const studentLinks = useSelector(
    (state) => state?.dashboard?.studentLinks || []
  );
  const labelRefs = useRef([]);

  const [overflowStates, setOverflowStates] = useState({});

  useEffect(() => {
    const newOverflowStates = {};
    labelRefs.current.forEach((ref, index) => {
      if (ref) {
        newOverflowStates[index] = ref.scrollWidth > ref.clientWidth;
      }
    });
    setOverflowStates(newOverflowStates);
  }, [studentLinks]);

  const getIcon = (title) => {
    const iconMap = {
      Edgenuity: (
        <svg
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="15"
            y="20"
            width="70"
            height="50"
            rx="4"
            fill="white"
            opacity="0.9"
          />
          <rect x="20" y="25" width="60" height="30" rx="2" fill="#667eea" />
          <circle cx="35" cy="40" r="4" fill="white" />
          <rect x="45" y="36" width="30" height="3" rx="1.5" fill="white" />
          <rect x="45" y="43" width="20" height="3" rx="1.5" fill="white" />
          <path
            d="M25 75 L50 60 L75 75"
            stroke="white"
            strokeWidth="3"
            fill="none"
          />
          <circle cx="50" cy="65" r="8" fill="white" />
        </svg>
      ),
      'Zoom Links': (
        <svg
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="20" y="30" width="60" height="40" rx="6" fill="white" />
          <circle cx="38" cy="45" r="6" fill="#2196F3" />
          <circle cx="62" cy="45" r="6" fill="#2196F3" />
          <path
            d="M30 60 Q35 55 38 55 Q41 55 46 60"
            stroke="#2196F3"
            strokeWidth="2"
            fill="none"
          />
          <path
            d="M54 60 Q59 55 62 55 Q65 55 70 60"
            stroke="#2196F3"
            strokeWidth="2"
            fill="none"
          />
          <path d="M75 35 L90 25 L90 55 L75 45 Z" fill="white" opacity="0.9" />
        </svg>
      ),
      'Teacher Pages': (
        <svg
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="25" y="35" width="50" height="45" rx="3" fill="white" />
          <path d="M30 40 L70 40" stroke="#FF6B6B" strokeWidth="2" />
          <path d="M30 50 L70 50" stroke="#FF6B6B" strokeWidth="2" />
          <path d="M30 60 L70 60" stroke="#FF6B6B" strokeWidth="2" />
          <path d="M30 70 L60 70" stroke="#FF6B6B" strokeWidth="2" />
          <circle cx="50" cy="25" r="10" fill="white" />
          <path d="M50 30 L50 45" stroke="white" strokeWidth="3" />
          <rect
            x="20"
            y="80"
            width="60"
            height="5"
            rx="2"
            fill="white"
            opacity="0.8"
          />
        </svg>
      ),
      Blueprint: (
        <svg
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="20"
            y="20"
            width="60"
            height="60"
            rx="3"
            fill="white"
            opacity="0.9"
          />
          <path
            d="M30 30 L70 30 L70 50 L50 50 L50 70 L30 70 Z"
            stroke="#20C997"
            strokeWidth="2"
            fill="none"
          />
          <circle cx="35" cy="35" r="2" fill="#20C997" />
          <circle cx="65" cy="35" r="2" fill="#20C997" />
          <circle cx="35" cy="65" r="2" fill="#20C997" />
          <line
            x1="40"
            y1="40"
            x2="60"
            y2="40"
            stroke="#20C997"
            strokeWidth="1"
            strokeDasharray="2,2"
          />
          <line
            x1="40"
            y1="60"
            x2="45"
            y2="60"
            stroke="#20C997"
            strokeWidth="1"
            strokeDasharray="2,2"
          />
          <line
            x1="60"
            y1="45"
            x2="60"
            y2="50"
            stroke="#20C997"
            strokeWidth="1"
            strokeDasharray="2,2"
          />
        </svg>
      ),
      'Email Submission Form': (
        <svg
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="15" y="30" width="70" height="45" rx="4" fill="white" />
          <path
            d="M15 30 L50 55 L85 30"
            stroke="#FFA500"
            strokeWidth="3"
            fill="none"
          />
          <path d="M15 30 L15 75 L50 55 Z" fill="white" opacity="0.7" />
          <path d="M85 30 L85 75 L50 55 Z" fill="white" opacity="0.7" />
          <circle cx="70" cy="45" r="8" fill="#FF8C00" />
          <path
            d="M68 45 L70 47 L73 43"
            stroke="white"
            strokeWidth="2"
            fill="none"
          />
        </svg>
      ),
    };

    return (
      iconMap[title] || (
        <svg
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="50" cy="50" r="35" fill="white" opacity="0.9" />
          <path
            d="M50 30 L50 55 L65 55"
            stroke="#667eea"
            strokeWidth="4"
            strokeLinecap="round"
          />
        </svg>
      )
    );
  };

  const getGradient = (title) => {
    const gradientMap = {
      Edgenuity: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      'Zoom Links': 'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)',
      'Teacher Pages': 'linear-gradient(135deg, #FF6B6B 0%, #C92A2A 100%)',
      Blueprint: 'linear-gradient(135deg, #20C997 0%, #0C8B69 100%)',
      'Email Submission Form':
        'linear-gradient(135deg, #FFA500 0%, #FF8C00 100%)',
    };

    return (
      gradientMap[title] || 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    );
  };

  return (
    <LaunchGrid>
      {studentLinks?.map((item, index) => (
        <Link
          href={item.url}
          target="_blank"
          key={index}
          sx={{
            textDecoration: 'none',
            width: 'fit-content',
            display: 'inline-block',
          }}
        >
          <Tooltip
            title={overflowStates[index] ? item.title : ''}
            placement="top"
            arrow
            disableHoverListener={!overflowStates[index]}
          >
            <LaunchCard
              data-testid={`launch-card-${index}`}
              gradient={getGradient(item.title)}
            >
              <LaunchIcon data-testid={`launch-icon-${index}`}>
                {getIcon(item.title)}
              </LaunchIcon>
              <LaunchLabel ref={(el) => (labelRefs.current[index] = el)}>
                {item.title}
              </LaunchLabel>
            </LaunchCard>
          </Tooltip>
        </Link>
      ))}
    </LaunchGrid>
  );
};

export default DashboardLaunch;
